import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { formatDateLabel } from '@/shared/utils/formatDateLabel';
import dayjs from '@/shared/lib/dayjs';

import ImgTime from '@/shared/pictures/time.svg';
import NoTeam from '@/shared/pictures/no_team.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '@/app/providers/StoreProvider';
import { IBet, IMatch } from '../types';
import { NumberWheel } from './NumberWheel';

interface PropsActualMatch {
    match: IMatch | null
    isActual:boolean
    isBet:IBet | undefined
    showTitle?: boolean
}



export const ActualMatch:FC<PropsActualMatch> = observer(({match, isActual, isBet, showTitle = true}) => {
    const location = useLocation();
    const navigation = useNavigate();
    const { forecastStore } = useStore();
    const locationDepth = location.pathname.split('/').filter((x)=>x !== '');


    if(!match) return null;
  return (
    <div onClick={()=> locationDepth[0] != 'forecast-set'? navigation(`/forecast-set?id=${match.id}`) : null} className="forecast-actual">

        {
            showTitle&& <h2 className='forecast-actual_title'>Актуальный матч:</h2>
        }

        <div className="forecast-actual_block">
            <div className="forecast-actual_teams">
                <div className="forecast-actual_team">
                    <div className="forecast-actual_team__icon">
                        <img src={match.home.logo} alt="icon"
                            onError={(e) => {
                               e.currentTarget.onerror = null;
                               e.currentTarget.src = NoTeam;
                            }}
                        />
                    </div>
                    <p className='forecast-actual_team__text'>{match.home.name}</p>
                </div>

                <div className="forecast-actual_date">
                    {formatDateLabel(dayjs(match.date)).title}
                    <span>
                      {formatDateLabel(dayjs(match.date)).date}
                    </span>
                </div>

                <div className="forecast-actual_team">
                    <div className="forecast-actual_team__icon">
                        <img src={match?.away.logo} alt="icon"
                            onError={(e) => {
                               e.currentTarget.onerror = null;
                               e.currentTarget.src = NoTeam;
                            }}
                        />
                    </div>
                    <p className='forecast-actual_team__text'>{match?.away.name}</p>
                </div>

            </div>


            {/* Сделать прогноз */}
            { locationDepth[0] != 'forecast-set' ?

                isBet?
                <div className="forecast-actual_info">
                    <p className='forecast-actual_info__text'>Ваш прогноз: {isBet.homeScore}:{isBet.awayScore}, {isBet.oviGoals}+{isBet.oviHelps}</p>
                </div>
                :
                <button type='button' className='forecast-actual_button'>
                    Сделать прогноз
                </button>
                :
                <>
                    {
                        isActual?
                            <div className="forecast-actual_scores">
                                <NumberWheel inputClass='forecast-actual_score' value={isBet?isBet.homeScore:forecastStore.bet.homeScore} onChange={(value) => forecastStore.setHomeScore(value)} disabled={!!isBet} />
                                <div className="forecast-actual_point">:</div>
                                <NumberWheel inputClass='forecast-actual_score' value={isBet?isBet.awayScore:forecastStore.bet.awayScore} onChange={(value)=>{forecastStore.setAwayScore(value)}} disabled={!!isBet}/>
                            </div>
                        : null
                    }
                </>
            }

        </div>
        { showTitle && <p className='forecast-actual_text'>Конкурс прогнозов абсолютно бесплатный, доставка приза победителю за наш счет.</p>}


    </div>
  );


});
